import React, {useEffect, useState} from 'react'
import { WithContext as ReactTags } from 'react-tag-input'
import "../../assets/scss/components/_selectTags.scss"

const SelectTags = ({ tags, getValues }) => {
  const [suggestions, setSuggestions] = useState([])
  const [selected, setSelected] = useState([])

  useEffect(() => {
    setSuggestions(tags)
  }, [tags])

  useEffect(() => {
    getValues(selected.map(item => item.id))
  }, [selected])

  const handleDelete = i => {
    setSelected(selected.filter((tag, index) => index !== i))
  }

  const handleAddition = async tag => {
    setSelected([...selected, tag])
  }

  return (
    <ReactTags
      tags={selected}
      suggestions={suggestions}
      handleDelete={handleDelete}
      handleAddition={handleAddition}
      placeholder={'Tags'}
      labelField={'name'}
      inline={true}
      inputFieldPosition={"inline"}
      allowDragDrop={false}
      minQueryLength={0}
      autocomplete={true}
      autofocus={false}
    />
  )
}

export default SelectTags
